import { render, staticRenderFns } from "./PrList.vue?vue&type=template&id=515eb0e7&scoped=true&"
import script from "./PrList.vue?vue&type=script&lang=js&"
export * from "./PrList.vue?vue&type=script&lang=js&"
import style0 from "./PrList.vue?vue&type=style&index=0&id=515eb0e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515eb0e7",
  null
  
)

export default component.exports